import React, { useEffect } from "react";
import RecordNotFound2 from "../../components/recordNotFound/SataNitFound";
import { useIds } from "../../hook/AdminContext";

export default function RecordNotAvailable() {
  const { setBreadCrumb } = useIds();
  const getHTMLForNoAccessMessage = () => {
    return `<h2>Oops! This content isn't available right now..</h2>
      <p class="mb-1">This content has been deleted or inactivated by an admin.</p>
      <p>If you believe this has been done in error, please contact support.</p>
      `;
  };

  useEffect(() => {
    setBreadCrumb([
      {
        name: `Home`,
        path: `/home`,
        active: false,
      },
      {
        name: `data-not-available`,
        path: `/data-not-available`,
        active: false,
      },
    ]);
  }, []);
  return (
    <div className="container-fluid row h-100 w-100">
      <div className="col-12 text-center">
        <RecordNotFound2
          html={getHTMLForNoAccessMessage()}
          showBackButton={false}
          showSupportButton={true}
        />
      </div>
    </div>
  );
}
